export const externalPage = {
  taskInvitation: "Task Invitation",
  interestedTaskMsg: "Are you interested in this task?",
  reject: "Reject",
  accept: "Accept",
  inviteAssigneeAcceptMsg: "Thank you for expressing interest in this task!",
  inviteAssigneeRejectMsg:
    "Thank you for reviewing this task. You have rejected the invitation.",
  approvalRequest: "Approval Request",
  POAssigneeAcceptMsg:
    "Do you confirm the details of this task, including the attached Purchase Order?",
  rejectRequest: "Reject Request",
  POAssigneeDeclineMsg:
    "Do you confirm the rejection of this task, including the attached Purchase Order?",
  rejectTask: "You have reject the task. Thank you",
  requestPayment: "Request Payment",
  requestPaymentMsg:
    "Do you want to confirm the invoice for the task with PO ({{poNumber}})?",
  confirm: "Confirm",
  requestPaymentSuccessMsg:
    "Your payment request has been successfully submitted.",
  uploadInvoice: "Upload Invoice",
  invoice: "Invoice",
  poAcceptMsg: "Thank you for accepting this task.",
  orderIsInDeliveredStatus:
    "This task is no longer available. To secure your future task with us, make sure you respond promptly to our task invite email. We look forward to working with you on upcoming projects.",
  // PO details labels
  poDetailsTitle: "Purchase Order Details",
  vendorInformation: "Vendor Information",
  vendorName: "Vendor Name",
  vendorAddress: "Vendor Address",
  vendorPhoneNumber: "Vendor Phone Number",
  vendorEmailAddress: "Vendor Email Address",
  vendorTaxRegistrationNumber: "Vendor Tax Registration Number",
  orderInformation: "Order Information",
  poIssuingDate: "P.O. Issuing Date",
  customerName: "Customer Name",
  customerOrderNumber: "Customer Order Number",
  tarjamaContact: "TARJAMA CONTACT",
  tarjamaContactPhoneNumber: "TARJAMA CONTACT PHONE NUMBER",
  fileName: "File Name",
  deadline: "Deadline",
  serviceDetails: "Service Details",
  unitCount: "Unit Count",
  unitPrice: "Unit Price",
  netSubtotal: "Net Subtotal",
  netTotal: "Net Total",
  // existing
  rejectionReason: "Rejection reason",
  rejectionReasonTitle: "Rejection Reason for Edit/Refund Request",
  rejectionReasonTitle2: "Do you want to proceed with Rejecting the Cancel Invoice request?",
  rejectionReasonAcceptMsg:
    "Do you want to proceed with confirming the invoice/order edit or refund request below?",
  rejectionReasonAcceptMsg2:
    "Do you want to proceed with Approving the Cancel Invoice request?",
  rejectionReasonDeclineMsg:
    "The edit or refund request for this invoice/order will be marked as Rejected.",
  rejectionReasonDeclineMsgPart2:
    "Kindly provide the reason for rejecting the request below. This will be shared with the requestor (PM).",
  rejectionReasonDeclineMsgPart3: "Orders:",
  rejectionReasonDeclineMsgPart4: "Invoice number:",
  rejectionReasonDeclineMsgPart4_1: "Grouped Invoice number:",
  rejectionReasonDeclineMsgPart5: "Requested by:",
  rejectionReasonDeclineMsgPart6: "Reason Provided by PM:",
  rejectionReasonDeclineMsgPart7: "Account name:",
  rejectionReasonDeclineMsgPart8: "Total amount with vat:",
  rejectionReasonAcceptEndMsg:
    "The edit or refund request has been confirmed and the requester has been notified.Thank you",
  rejectionReasonDeclineEndMsg:
    "Your request has been rejected, and the rejection reason has been successfully recorded.Thank you",
};
